import PropTypes from 'prop-types';
import React from 'react';

const cx = require('classnames');

class StatusOverride extends React.Component {

  static propTypes = {
    componentParam: PropTypes.string.isRequired,
    isActive: PropTypes.bool,
    onClick: PropTypes.func.isRequired,
  };

  static defaultProps = {
    isActive: false,
  };

  render () {
    let classNames = 'component-status-override';

    if (this.props.isActive) {
      classNames = cx(classNames, 'derived');
    } else {
      classNames = cx(classNames, 'override');
    }

    return (
      <div
        className={classNames}
        onClick={this.props.onClick}
        id={`override-${this.props.componentParam}`} />
    );
  }
}

module.exports = StatusOverride;



// WEBPACK FOOTER //
// ./app/assets/javascripts/components/manage/pages/components/status_override.jsx